import { useCallback, useContext, useEffect, useState } from "react";
import DocumentService from "../../../services/DocumentService";
import AuthContext from "../../../auth/AuthContext";
import AlertService from "../../../services/AlertService";
import DocumentViewer from "./Viewer";
import { Skeleton } from "primereact/skeleton";

const Attachment = ({ no, attachment, title }) => {
    no++;
    const authContext = useContext(AuthContext);
    const [pdfData, setPDFData] = useState();
    const [contentType, setContentType] = useState();
    const [loading, setLoading] = useState(false);

const downloadFile = useCallback(async (signal) => { 
        setLoading(true);
        try {
          const data = await DocumentService.GetFile(
            attachment.id,
            authContext,
            signal 
          );

          if (signal?.aborted) return; 

          if (data.isSuccess) {
            setContentType(data.data.contentType);
            setPDFData(data.data.filePath);
          } else {
            AlertService.error(data.errorMessage);
          }
        } catch (err) {
          if (err.name === "AbortError") return; 
        } finally {
          if (!signal?.aborted) setLoading(false); 
        }
      }, [attachment.id, authContext]);

useEffect(() => {
    const controller = new AbortController(); 
    downloadFile(controller.signal);
    return () => controller.abort(); 
  }, [downloadFile, authContext]);

    return (
        <>
            {loading ? (
                <div
                    style={{
                        border: "1px solid #ddd",
                        borderRadius: "8px",
                        overflow: "hidden",
                        maxHeight: "72vh",

                    }}
                >
                    <div style={{ background: "#f4f4f4", padding: "0.5rem", display: "flex", gap: "0.5rem" }}>
                        <Skeleton width="2rem" height="2rem" borderRadius="4px" />
                        <Skeleton width="2rem" height="2rem" borderRadius="4px" />
                        <Skeleton width="3rem" height="2rem" borderRadius="4px" />
                        <Skeleton width="4rem" height="2rem" borderRadius="4px" />
                        <Skeleton width="2rem" height="2rem" borderRadius="4px" style={{ marginLeft: "auto" }} />
                    </div>
                    <div style={{ padding: "1rem" }}>
                        <Skeleton width="100%" height="700px" borderRadius="6px" />
                    </div>
                </div>
            ) : (
                pdfData && (
                    <div>
                        <DocumentViewer
                            src={pdfData}
                            contentType={contentType}
                            title={title}
                        />
                    </div>
                )
            )}
        </>
    );
};

export default Attachment;
